
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace-brands",
      function () {
        return require("private-next-pages/marketplace-brands.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace-brands"])
      });
    }
  